var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLighting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6668 1.33337C12.0742 1.33337 11.5527 1.72449 11.3868 2.29337L6.72009 18.2934C6.60258 18.6963 6.68162 19.131 6.93343 19.4667C7.18523 19.8024 7.58042 20 8.00009 20H13.1564L12.0104 29.168C11.9337 29.7816 12.2889 30.3674 12.8685 30.583C13.4481 30.7986 14.0998 30.5875 14.4428 30.073L25.1095 14.073C25.3823 13.6638 25.4077 13.1378 25.1757 12.7042C24.9436 12.2707 24.4918 12 24.0001 12H19.2574L22.5819 3.13487C22.7354 2.72541 22.6784 2.26668 22.4293 1.90725C22.1802 1.54781 21.7707 1.33337 21.3334 1.33337H12.6668Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/lighting.280c8b54c594aebe9a4d8c36b79b4070.svg";
export { ForwardRef as ReactComponent };